import { forwardRef, useImperativeHandle, useState } from "react";
import { Modal } from "antd";

const Modals = forwardRef(({ children, reference, ...props }) => {
  const [visible, setVisible] = useState(false);
  useImperativeHandle(reference, () => ({
    showModal: () => {
      setVisible(true);
    },
    hideModal: () => {
      setVisible(false);
    },
  }));

  const handleCancel = () => {
    setVisible(false);
    "onCancel" in props && props.onCancel();
  };

  return (
    <Modal
      centered={true}
      open={visible}
      onCancel={handleCancel}
      destroyOnClose={true}
      maskClosable={false}
      {...props}
    >
      {children}
    </Modal>
  );
});
export default Modals;
